<template>
  <table
    class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400"
  >
    <thead class="text-xs text-gray-700 uppercase bg-gray-50 sticky -top-2 z-20">
      <tr>
        <slot name="head" />
      </tr>
    </thead>

    <tbody>
      <tr
        v-for="(row, index) in data"
        :key="index"
        class="bg-white border-b hover:bg-gray-50"
      >
        <!-- foto, nome e função -->
        <th
          scope="row"
          class="flex items-center px-6 py-4 text-gray-900 whitespace-nowrap"
        >
          <!-- foto -->
          <img
            class="w-10 h-10 rounded-full mt-auto mb-auto" 
            v-if="row['users']['image_profile']"
            :src="imageServe + row['users']['image_profile']"
            :alt="'Foto de ' + row['users']['name']"
          />
          <component 
            v-else
            class="w-10 h-10 rounded-full text-gray-400"
            :is="PhUserCircle"
          ></component>

          <!-- nome e função -->
          <div class="ps-3">
            <div class="text-base font-semibold">
              {{ row['users']["name"] }}
            </div>

            <div class="font-normal text-gray-500">
              {{ row['users']["function"] }}
            </div>
          </div>
        </th>

        <!-- registro -->
        <td scope="row" class="px-6 py-4 whitespace-nowrap">
          <div>
            <div
              title="tipo de registro"
              class="text-base text-gray-900 font-bold"
            >
              {{ row["type"] }}
            </div>

            <div class="font-normal text-gray-500 lowercase">
              data: {{ formatDate(row["created_at"]) ?? 'não informado' }}
            </div>
            <div class="font-normal text-gray-500 lowercase">
              horario: {{ row["registeredTime"] ?? 'não informado' }}
            </div>
          </div>
        </td>

        <!-- ações -->
        <td class="px-4 py-2 sticky -right-5 z-10">
          <div class="flex justify-center font-medium">
            <!-- relatórios -->
            <a
              title="Detalhes do registro"
              @click="showReport(row)"
              class="text-[#227e92] ml-1 hover:underline cursor-pointer bg-white py-2 px-2"
            >
              <component :is="PhInfo" class="h-7 w-7 md:h-6 md:w-6" />
            </a>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
import moment from 'moment'
import { PhFileDoc, PhInfo, PhUserCircle } from '@phosphor-icons/vue'
import { defineProps, ref } from 'vue'
import { storeApp } from '@/store'

const imageServe = process.env.VUE_APP_IMAGE_SERVE + 'storage/'
const defaultImg = require('@/assets/logo/icon.png')

const props = defineProps({
  data: [Object, Array]
})

const emit = defineEmits(['delete'])

function formatDate (date) {
  if (date !== null) {
    return moment(date).format('DD/MM/Y')
  }

  return 'não informado'
}

</script>
